import { IProjectModulePipeline } from '../../interfaces/iproject-module-pipeline';
import { Project } from '../project';

export class ProjectModulePipelineBase {
  ProjectModulePipelineId: number;
  ProjectId: number;
  Description: string;
  PipeMaterial: string | null;
  PipeNominalDiameter: number | null;
  PressureRating: number | null;
  PressureRatingUnitOfMeasure: string | null;
  GisEstimatedGasLiftLineLength: number | null;
  PipelineLength: number | null;
  BoreLength: number | null;
  LineCrossings: number | null;
  RockPercent: number | null;
  IsComingled: boolean | null;
  IsPiggingLine: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Project?: Project;

  constructor(item?: IProjectModulePipeline) {
    if (item) {

      this.ProjectModulePipelineId = item.ProjectModulePipelineId;
      this.ProjectId = item.ProjectId;
      this.Description = item.Description;
      this.PipeMaterial = item.PipeMaterial;
      this.PipeNominalDiameter = item.PipeNominalDiameter;
      this.PressureRating = item.PressureRating;
      this.PressureRatingUnitOfMeasure = item.PressureRatingUnitOfMeasure;
      this.GisEstimatedGasLiftLineLength = item.GisEstimatedGasLiftLineLength;
      this.PipelineLength = item.PipelineLength;
      this.BoreLength = item.BoreLength;
      this.LineCrossings = item.LineCrossings;
      this.RockPercent = item.RockPercent;
      this.IsComingled = item.IsComingled;
      this.IsPiggingLine = item.IsPiggingLine;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Project = new Project(item.Project);
    }
  }
}